export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "data.worker.49214034572d0f550f35.worker.js");
}
